<template>
  <main>
    <section-view class="header" title="营养素">
      <div class="name fx">
        <span>
          <b>{{title}}</b>
          <i></i>
        </span>
      </div>
    </section-view>

    <!-- 检测指标 -->
    <section-view title="检测指标">
      <div class="indicator">
        <div class="thumb">
          <div class="separator"></div>
          <div class="bar" :style="{left: Math.floor((indicator * 5) + 50) + '%'}">
            <span>{{indicator}}</span>
          </div>
        </div>
        <div class="label">
          <span>异常</span>
          <span>正常</span>
        </div>
      </div>
    </section-view>

    <text-card
        v-if="propose"
        title="营养素调理建议"
        :content="propose"
    ></text-card>

    <waterfall-card
        v-if="dynamics.length > 0"
        title="动态跟踪模式"
        :list="dynamics"
        labelKey="time"
        :valueKey="stackValueKey"
        stack="diff"
        line="av"
        format
        tips
        @tip="interpret = true"
    ></waterfall-card>

    <!-- 平均值状态图 -->
    <waterfall-card
        v-if="averageStatus.length > 0"
        title="平均值状态图"
        :list="averageStatus"
        labelKey="time"
        colorKey="color"
        :valueKey="avValueKey"
        format
    ></waterfall-card>

    <!-- 影响身体关联项 -->
    <tag-card title="影响身体关联项" :list="relations" @selected="row => $router.push({path: '/details', query: {code: row.system_code, title: row.item_dict_name, color: row.color, ...query}})"></tag-card>

    <text-card
        v-if="explain"
        title="项目说明"
        :content="explain"
    ></text-card>

    <text-card
        v-if="lack"
        title="缺乏易患"
        :content="lack"
    ></text-card>

    <text-card
        v-if="food"
        title="食物来源"
        :content="food"
    ></text-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import {getReportLoopItemNutrition} from "../net/api";
  import SectionView from "../components/SectionView";
  import TextCard from "../components/TextCard";
  import TagCard from "../components/TagCard";
  import WaterfallCard from "../components/WaterfallCard";
  import DialogView from "../components/DialogView";

  export default {
    name: "Nutrition",
    components: {DialogView, WaterfallCard, TagCard, TextCard, SectionView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        code: '',
        title: '',

        // 指标
        indicator: 0,
        // 营养素调理建议
        propose: '',
        // 影响身体的关联项
        relations: [],
        // 项目说明
        explain: '',

        // 缺乏易患
        lack: '',
        // 食物来源
        food: '',

        stackValueKey: {
          one: '初值',
          two: '终值',
        },

        avValueKey: {
          av: '均值',
        },

        // 动态跟踪模式
        dynamics: [],
        // 平均值状态图
        averageStatus: [],

        // 报告等级列表
        levels: [],

        // 解读说明弹窗
        interpret: false
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.title = query.title;
      this.code = query.code;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportLoopItemNutrition({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,

          system_code: this.code
        }).then((data) => {
          this.levels = data.colorData;
          this.propose = data.show_tiaoli;
          this.indicator = Number(data.show_zhibiao);
          this.relations = data.show_shentiguanlian;
          this.explain = data.item_explain;
          this.lack = data.show_quefayihuan;
          this.food = data.show_shiwulaiyuan;
          this.dynamics = data.show_dongtai;
          this.averageStatus = data.show_pingjunzhi || [];
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    .name {
      position: relative;
      padding-top: 60px;

      span {
        position: relative;
        padding: 0 10px;
      }

      b {
        position: relative;
        height: 36px;
        font-size: 50px;
        color: #333333;
        line-height: 36px;
        font-weight: 500;
        z-index: 1;
      }

      i {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -14px;
        content: "";
        display: block;
        height: 18px;
        background: #6CA0EC;
        border-radius: 9px;
      }
    }
  }

  .indicator {
    padding-top: 56px;
    .thumb {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      background: #F5F6F9;

      .separator {
        width: 2px;
        height: 20px;
        background: #333333;
      }

      .bar {
        position: absolute;
        width: 20px;
        height: 20px;
        background: #6CA0EC;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        margin-left: -10px;

        span {
          position: absolute;
          width: 100px;
          height: 36px;
          background: #6CA0EC;
          border-radius: 18px;
          font-size: 24px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          bottom: 40px;

          &:after {
            content: "";
            display: block;
            position: absolute;
            bottom: -10px;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #6CA0EC;
          }
        }
      }
    }

    .label {
      display: flex;
      font-size: 30px;
      color: #333333;
      padding-top: 20px;
      align-items: center;

      span {
        flex: 1;
        display: flex;
        justify-content: center;
      }
    }
  }
</style>